import moment from "moment";
const datenow = moment().format("YYYY-MM-DD");

export const ValCovid = async (data) => {
  const errors = [];

  if (!data.last_vaksin) {
    errors.push({ type: "last_vaksin", message: "tanggal tidak boleh kosong" });
  } else {
    if (!moment(data.last_vaksin.toString()).isBefore(datenow, "day")) {
      if (!moment(data.last_vaksin.toString()).isSame(datenow, "day"))
        errors.push({
          type: "last_vaksin",
          message: "tidak boleh memilih hari besok",
        });
    }
  }

  if (!data.tujuan_pemeriksaan) {
    errors.push({
      type: "tujuan_pemeriksaan",
      message: "tujuan pemeriksaan tidak boleh kosong",
    });
  } else {
    if (Number(data.tujuan_pemeriksaan) === 8) {
      if (!data.tujuan_lain) {
        errors.push({
          type: "tujuan_lain",
          message: "lain-lain tidak boleh kosong",
        });
      }
    }

    if (Number(data.tujuan_pemeriksaan) === 2) {
      if (!data.negara_tujuan) {
        errors.push({
          type: "negara_tujuan",
          message: "tujuan negara tidak boleh kosong",
        });
      }

      if (!data.no_passport) {
        errors.push({
          type: "no_passport",
          message: "no passport tidak boleh kosong",
        });
      }
    }
  }

  if (data.is_vacation) {
    if (!data.tgl_bepergian) {
      errors.push({
        type: "tgl_bepergian",
        message: "tanggal bepergian tidak boleh kosong",
      });
    } else {
      if (!moment(data.tgl_bepergian.toString()).isBefore(datenow, "day")) {
        if (!moment(data.tgl_bepergian.toString()).isSame(datenow, "day"))
          errors.push({
            type: "tgl_bepergian",
            message: "tidak boleh memilih hari besok",
          });
      }
    }

    if (!data.tujuan_bepergian) {
      errors.push({
        type: "tujuan_bepergian",
        message: "tujuan bepergian tidak boleh kosong",
      });
    }
  }

  return errors;
};
